import CascaderPanel from './src/cascader-panel';

export default CascaderPanel;
